import React, { useState } from 'react';
import '../styles/ActionModal.css';
import { isDevelopmentTimer } from '../utils/timerMode';

type Props = {
    isOpen: boolean;
    type: 'grantGrace' | 'ban';
    courses: { id: string; name: string }[];
    defaultDays?: number;
    onCancel: () => void;
    onConfirm: (courseId: string, days?: number) => void;
};

export default function ActionModal({
                                        isOpen,
                                        type,
                                        courses,
                                        defaultDays = 7,
                                        onCancel,
                                        onConfirm
                                    }: Props) {
    const [courseId, setCourseId] = useState(courses[0]?.id || '');
    const [days, setDays] = useState(defaultDays);

    if (!isOpen) return null;

    return (
        <div className="am-overlay">
            <div className="am-dialog">
                <div className="am-dialog-header">
                    <div className="am-icon">
                        {type === 'grantGrace' ? '⏰' : '🚫'}
                    </div>
                    <h2 className="am-dialog-title">
                        {type === 'grantGrace' ? 'Grant Grace Period' : 'Ban Enrollment'}
                    </h2>
                </div>

                <p className="am-dialog-description">
                    {type === 'grantGrace'
                        ? 'Allow additional time for students to complete their enrollment. This extension will be applied to the selected course.'
                        : 'Ban this student’s access to the selected course. They will no longer be able to view course materials or participate.'}
                </p>

                {/*{type === 'grantGrace' && (*/}
                {/*    <div className="am-warning">*/}
                {/*        <span className="am-warning-icon">⚠️</span>*/}
                {/*        /!*<span>Students will receive an automatic notification of the grace period extension.</span>*!/*/}
                {/*    </div>*/}
                {/*)}*/}

                <form className="am-form">
                    <div className="am-form-group">
                        <div className="am-form-row">
                            <div className="am-form-field">
                                <label htmlFor="course" className="am-form-label">Select Course</label>
                                <div className="am-select-wrapper">
                                    <select
                                        id="course"
                                        className="am-form-select"
                                        value={courseId}
                                        onChange={e => setCourseId(e.target.value)}
                                    >
                                        {courses.map(c => (
                                            <option key={c.id} value={c.id}>{c.name}</option>
                                        ))}
                                    </select>
                                </div>
                            </div>

                            {type === 'grantGrace' && (
                                <div className="am-form-field am-form-field--narrow">
                                    <label htmlFor="days" className="am-form-label">
                                        {isDevelopmentTimer ? 'Minutes' : 'Days'}
                                    </label>
                                    <input
                                        type="number"
                                        id="days"
                                        className="am-form-input"
                                        min={1}
                                        max={30}
                                        value={days}
                                        onChange={e => setDays(+e.target.value)}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                </form>

                <div className="am-actions">
                    <button type="button" className="am-btn am-btn--secondary" onClick={onCancel}>
                        Cancel
                    </button>
                    <button
                        type="button"
                        className="am-btn am-btn--primary"
                        onClick={() => onConfirm(courseId, days)}
                    >
                        {type === 'grantGrace' ? 'Grant Grace Period' : 'Ban Enrollment'}
                    </button>
                </div>
            </div>
        </div>
    );
}
